/*
 * Copyright (c) 2016-present Invertase Limited & Contributors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this library except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */

import React from 'react';
import { Link } from './Link';
import { Tooltip } from '@invertase/ui';

function SourceLink({ source }: { source: string }) {
  return (
    <Tooltip label="Jump to source">
      <Link
        to={source}
        target="_blank"
        className="flex items-center justify-center text-sm text-gray-400 hover:text-gray-500"
      >
        <span>{'<'}</span>
        <span>{'/>'}</span>
      </Link>
    </Tooltip>
  );
}

export { SourceLink };
